import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

// Hero Banner Assets
import Image1 from "./assets/HeroBanners/sathyas.webp";
import Image2 from "./assets/HeroBanners/maha.webp";
import Image3 from "./assets/HeroBanners/vajram.webp";
import Image4 from "./assets/HeroBanners/subham.webp";
import MobileImage3 from "./assets/mobile/mobile_maha.png";

import "./App.css";

// Layout & Global Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

// Home Page Sections
import Slider from "./components/Slider";
import About from "./components/About";
import VideoPage from "./components/VideoPage";
import OnGoingProjects from "./components/OnGoing";
import CompletedPlotProjects from "./components/CompletedProjects";
import VajramVideo from "./components/VajramVideo";
import Plots from "./components/Plots";
import Locations from "./components/Locations";
import ContactMap from "./components/ContactMap";

// Dynamic Details Page
import ProjectDetails from "./pages/LayoutDetailPage";

// Dedicated Home Component containing your landing page sections
const Home = () => {
  const images = [
    {
      image: Image1,
      link: '/project/satyas-elite'
    },
    {
      image: Image2,
      link: '/project/mahalakshmi-golden-city'
    },
    {
      image: Image3,
      link: '/project/vajram'
    },
    {
      image: Image4,
      link: '/project/subham-avenues'
    }
  ];
  const mobileImages = [MobileImage3];
  const tabImages = [Image1, Image2, Image3, Image4];
  const effects = ["fade", "coverflow", "flip", "zoom", "rotate"];

  return (
    <>
      <section id="home" className="w-full lg:pt-[50px] pt-[35px] bg-transparent">
        <Slider
          images={images}
          mobileImages={mobileImages}
          tabImages={tabImages}
          effects={effects}
          interval={4000}
        />
      </section>

      <section id="about">
        <About />
        <VideoPage />
      </section>

      <section id="ongoingProjects">
        <OnGoingProjects />
      </section>

      <section id="completedProjects">
        <CompletedPlotProjects />
      </section>

      <section>
        <VajramVideo />
      </section>

      <section id="plots">
        <Plots />
      </section>

      <section id="locations">
        <Locations />
      </section>

      <section id="contact">
        <ContactMap />
      </section>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App min-h-screen overflow-x-hidden flex flex-col justify-between">
        {/* Persistent across all pages */}
        <Navbar />

        <main className="flex-grow">
          <Routes>
            {/* Landing page route */}
            <Route path="/" element={<Home />} />

            {/* Dynamic Project Details route by id: e.g. /project/vajram */}
            <Route path="/project/:id" element={<ProjectDetails />} />
          </Routes>
        </main>

        {/* Persistent across all pages */}
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;